/**
 *
 *
 *
 *
 *
 *
 *
 */
import { o_global } from "@gr-common/async/namespaces";
/**
 *
 *
 */
export const events = o_global.events;
/**
 *
 *
 */
export const eventQBus = o_global.eventQBus;
